import {
  ExternalBankAccount,
  ExternalBankAccountStatus,
  PaymentMethodCapability
} from "@wingspanhq/wingspan-api-sdk";
import { selectorExternalBankAccountVerificationPending } from "./selectorExternalBankAccountVerificationPending";

export const selectorExternalBankAccountFundingReady = (
  externalBankAccount: ExternalBankAccount
) =>
  (!!externalBankAccount.capabilities?.includes(
    PaymentMethodCapability.CHARGE
  ) ||
    selectorExternalBankAccountVerificationPending(externalBankAccount)) &&
  externalBankAccount.status !== ExternalBankAccountStatus.REMOVED &&
  externalBankAccount.status !== ExternalBankAccountStatus.FAILED;
